import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import { isPrerender } from '../utils/isPrerender';
import SectionTitle from './SectionTitle';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const FB_PAGE = 'https://www.facebook.com/TTBriancon';

// Logo Facebook affiché à la place de l'image quand la publication n'en a pas.
const FacebookLogo = () => (
  <svg className="post-fb-logo" viewBox="0 0 24 24" role="img" aria-label="Facebook">
    <path
      fill="currentColor"
      d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"
    />
  </svg>
);

const SocialWall = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (isPrerender()) return;
    let cancelled = false;

    axios
      .get('/api/facebook-posts.php', { timeout: 10000 })
      .then((res) => {
        if (cancelled) return;
        setPosts(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  // slidesToShow adapté au nombre de posts pour éviter les clones / cases vides.
  const show = (n) => Math.max(1, Math.min(n, posts.length));
  const slickSettings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    // > 1200px : le carrousel prend toute la largeur et montre un maximum de posts.
    slidesToShow: show(5),
    infinite: posts.length > 5,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: show(4), infinite: posts.length > 4 } },
      { breakpoint: 1200, settings: { slidesToShow: show(3), infinite: posts.length > 3 } },
      { breakpoint: 1100, settings: { slidesToShow: show(2), infinite: posts.length > 2 } },
      { breakpoint: 700, settings: { slidesToShow: 1, infinite: posts.length > 1 } },
    ],
  };

  return (
    <div className="section section--seam section--rose social-wall-fb">
      <SectionTitle overline="Actualités">Suivez-nous</SectionTitle>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : posts.length > 0 ? (
        <Slider {...slickSettings} className="posts-slider">
          {posts.map((post) => (
            <div key={post.id || post.permalink_url} className="post-slide">
              <a
                href={post.permalink_url || FB_PAGE}
                target="_blank"
                rel="noopener noreferrer"
                className="post-card"
              >
                <div
                  className={`post-image-container${
                    post.full_picture ? '' : ' post-image-container--placeholder'
                  }`}
                >
                  {post.full_picture ? (
                    <img
                      src={post.full_picture}
                      alt=""
                      className="post-image"
                      decoding="async"
                      loading="lazy"
                    />
                  ) : (
                    <FacebookLogo />
                  )}
                </div>
                <div className="post-body">
                  {post.message && <p className="post-message">{post.message}</p>}
                  {post.created_time && (
                    <span className="post-date">Publié le {formatDate(post.created_time)}</span>
                  )}
                </div>
              </a>
            </div>
          ))}
        </Slider>
      ) : (
        <p className="text-center">
          {error
            ? 'Les publications ne sont pas disponibles pour le moment.'
            : 'Aucune publication récente.'}
        </p>
      )}

      <p className="social-wall-cta text-center">
        <a className="btn btn-secondary" href={FB_PAGE} target="_blank" rel="noopener noreferrer">
          Voir la page Facebook
        </a>
      </p>
    </div>
  );
};

export default SocialWall;
